import React, { Fragment } from "react";
import PropTypes from "prop-types";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import flagFields from "./flagFields";
import FormGrid from "../../../../../../../components/forms/FormGrid";
import ActionButtons from "../../../../../../../components/forms/ActionButtons";
import FormikForm from "../../../../../../../components/forms/FormikForm";
import propTypes from "../../../../../../../constants/propTypes";

const FlagForm = ({ onSubmit, initialValues, dataComponentId }) => {
  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={BWModels.loadSchema("Flag")}
    >
      {({ handleSubmit, values, errors, ...formikProps }) => (
        <Fragment>
          <FormGrid
            fields={flagFields}
            values={values}
            errors={errors}
            {...formikProps}
          />

          <ActionButtons
            onSend={handleSubmit}
            isModal={true}
            listeners={[dataComponentId]}
          />
        </Fragment>
      )}
    </FormikForm>
  );
};

FlagForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isUpdate: PropTypes.bool,
  initialValues: propTypes.flag,
  dataComponentId: PropTypes.string.isRequired,
};

export default FlagForm;
